import React from 'react';
import {StatsSection} from "../../../components/sections/stats/StatsSection";
import {TopUsersSection} from "../../../components/sections/topUsers/TopUsersSection";
import {ReqStatsSection} from "../../../components/sections/reqStats/ReqStatsSection";

export const MainPage = () => {
  return (
      <div>
        <div className={"mt-6"}>
          <StatsSection/>
        </div>

        <div className='row g-5 g-xxl-8 mt-2'>
          <div className='col-xl-6'>
            <TopUsersSection/>
          </div>
          <div className='col-xl-6'>
            <ReqStatsSection/>
          </div>
        </div>
      </div>
  );
};